import { OpenInNew } from '@mui/icons-material'
import { Box, Stack, Typography, IconButton, Tooltip } from '@mui/material'
import { OrgCredentialType } from '@/types/credentials'
import { LiveListEntity } from '@/types/live-lists'

type VendorDetailsProps = {
  credentialType: OrgCredentialType
  entityJson: LiveListEntity
}

export default function VendorDetails({
  credentialType,
  entityJson,
}: VendorDetailsProps) {
  const usesAddress = credentialType.supports.vendor_uses_address
  if (!usesAddress && !entityJson.entity_url) return null

  const address = entityJson.pd_address

  return (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
      >
        {!!usesAddress && (
          <Stack direction="row" spacing={2} alignItems="center">
            <Box>
              <Typography variant="caption" color="text.secondary">
                Address
              </Typography>
              {address?.city ? (
                <>
                  <Typography variant="body2">{address.street1}</Typography>
                  <Typography variant="body2">{address.street2}</Typography>
                  <Typography variant="body2">
                    {address.city}, {address.state} {address.zip}
                  </Typography>
                </>
              ) : (
                <Typography variant="body2">None</Typography>
              )}
            </Box>
          </Stack>
        )}
        {entityJson.entity_url && (
          <Box>
            <Tooltip title={`Open Vendor in ${credentialType.name}`}>
              <IconButton
                sx={{ flexShrink: 0 }}
                component={'a'}
                href={entityJson.entity_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <OpenInNew />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      </Stack>
    </Box>
  )
}
